import React, {MouseEventHandler, useContext} from "react";
import {GenericComponentModel, SelectElementModelBE, SelectElementModelFE,} from "../../../api/types/generic";
import {useRecoilState} from "recoil";
import {useTranslation} from "react-i18next";
import SearchFilters from "../../../common/components/SearchFilters";
import {commercialSegmentListAtom} from "../../../state/commercialSegmentsAtom";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";

const AncillaryFilters = ({
                              handleClickSearch,
                              handleClickResetSearch,
                              types,
                              testFilters,
                              setTestFilters
                          }: {
    handleClickSearch: MouseEventHandler<HTMLButtonElement>
    handleClickResetSearch: MouseEventHandler<HTMLButtonElement>
    types: string[]
    testFilters: any
    setTestFilters: any
}) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Recoil
    const [commercialSegmentList] = useRecoilState<SelectElementModelFE[]>(commercialSegmentListAtom);

    // Use Context
    const {
        globalData: {user},
    } = useContext(GlobalContext);
    const legalEntityOptions: SelectElementModelFE[] = user.legalEntities?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:legalEntities.'.concat(el.name))
        })
    );

    const dealerOptions: SelectElementModelFE[] = user.dealers.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:dealers.'.concat(el.name))
        })
    );

    const filtersOutOfCollapse: GenericComponentModel[] = [
        {
            name: "ancillaryCode",
            value: testFilters.ancillaryCode,
            label: `${t("pricing:ancillary.form.labels.code")}`,
            handleChange: (value: string) => setTestFilters({
                ...testFilters,
                ancillaryCode: value
            }),
            options: [],
            type: "TextField"
        },
        {
            name: "commercialSegmentId",
            value: testFilters.commercialSegmentId,
            label: `${t("pricing:ancillary.form.labels.commercialSegment")}`,
            handleChange: (value: SelectElementModelFE) => setTestFilters({
                ...testFilters,
                commercialSegmentId: value,
                commercialCategoryId: null
            }),
            options: commercialSegmentList,
            type: "Autocomplete"
        },
        {
            name: "type",
            value: testFilters.ancillaryType,
            label: `${t("pricing:ancillary.form.labels.type")}`,
            handleChange: (value: string) => setTestFilters({...testFilters, ancillaryType: value}),
            options: types,
            type: "Autocomplete"
        }
    ];
    const filtersInCollapse: GenericComponentModel[] = [
        {
            name: "reservationFrom",
            value: testFilters.reservationFrom as string,
            options: [],
            label: `${t("pricing:ancillary.form.labels.reservationFrom")}`,
            handleChange: (value: string) => setTestFilters({...testFilters, reservationFrom: value}),
            type: "Date"
        },
        {
            name: "reservationTo",
            value: testFilters.reservationTo as string,
            options: [],
            label: `${t("pricing:ancillary.form.labels.reservationTo")}`,
            handleChange: (value: string) => setTestFilters({...testFilters, reservationTo: value}),
            type: "Date"
        },
        {
            name: "pickupDateFrom",
            value: testFilters.pickupDateFrom as string,
            options: [],
            label: `${t("pricing:ancillary.form.labels.pickupDateFrom")}`,
            handleChange: (value: string) => setTestFilters({...testFilters, pickupDateFrom: value}),
            type: "Date"
        },
        {
            name: "pickupDateTo",
            value: testFilters.pickupDateTo as string,
            options: [],
            label: `${t("pricing:ancillary.form.labels.pickupDateTo")}`,
            handleChange: (value: string) => setTestFilters({...testFilters, pickupDateTo: value}),
            type: "Date"
        },
        {
            name: "legalEntities",
            value: testFilters.legalEntities as SelectElementModelFE,
            label: `${t("pricing:ancillary.form.labels.legalEntity")}`,
            handleChange: (value: SelectElementModelFE) =>
                setTestFilters({...testFilters, legalEntities: value}),
            options: legalEntityOptions || [],
            type: "AutocompleteM",
            hide: user.legalEntities.length === 1 && user.dealers.length === 1 ? true : false
        },
        {
            name: "dealers",
            value: testFilters.dealers as SelectElementModelFE,
            label: `${t("pricing:ancillary.form.labels.dealer")}`,
            handleChange: (value: SelectElementModelFE) =>
                setTestFilters({...testFilters, dealers: value}),
            options: dealerOptions || [],
            type: "AutocompleteM",
            hide: user.legalEntities.length === 1 && user.dealers.length === 1 ? true : false
        },
    ];

    return (
        <SearchFilters
            filtersOutOfCollapse={filtersOutOfCollapse}
            filtersInCollapse={filtersInCollapse}
            handleClickSearch={handleClickSearch}
            handleClickResetSearch={handleClickResetSearch}
        />
    );
};

export default AncillaryFilters;